import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { AchBusinessContact } from "../../definitions/ach-business-contact";
import { AchFundingRequest } from "../../definitions/ach-funding-request";
import { HttpOptionsBuilder } from "../../definitions/api/http-options-builder";
import { ChargeCreditCardRequest } from "../../definitions/charge-credit-card-request";
import { UserStatusResponse } from "../../definitions/user-status-response";
import { AppConfigService } from "../app.config.service";
import { ApiService } from "./api.service";
import { BaseApiService } from "./base-api.service";

@Injectable({ providedIn: "root" })
export class ConsumerAdminService extends BaseApiService {
	constructor(
		private api: ApiService,
		appConfigService: AppConfigService
	) {
		super("mpapi/consumer-admin", appConfigService.getConfigValue("API_ENDPOINT"));
	}

	chargeCreditCard(request: ChargeCreditCardRequest): Observable<void> {
		return this.api.post(this.url(`/charge-card-profile`), request);
	}

	fundAch(achFundingRequest: AchFundingRequest): Observable<string> {
		return this.api
			.post<{
				id: string;
			}>(this.url("/fund-ach-account-for-purchases"), achFundingRequest, undefined)
			.pipe(map((res) => res.id));
	}

	inviteUser(body: any): Observable<any> {
		return this.api.post(this.url(`/create-user-account`), body, "errors.invite-user-failed");
	}

	removeBankAccount(accountId: string): Observable<void> {
		const options = HttpOptionsBuilder.builder().param("accountId", accountId).build();
		return this.api.delete<void>(this.url(`/remove-bank-account`), undefined, options);
	}

	removeUser(id: string): Observable<void> {
		return this.api.delete<void>(
			this.url(`/remove-consumer-user-account/${id}`),
			"errors.remove-user-failed"
		);
	}

	updateBankAccountName(accountId: string, accountName: string): Observable<any> {
		const options = HttpOptionsBuilder.builder()
			.param("accountId", accountId)
			.param("accountName", accountName)
			.build();
		return this.api.put(this.url(`/update-bank-account-name`), null, undefined, options);
	}

	updateBeneficialOwner(boId: string, bo: AchBusinessContact): Observable<void> {
		return this.api.put<void>(this.url(`/update-beneficial-owner/${boId}`), bo);
	}

	updateUserRoles(id: string, data: any): Observable<any> {
		return this.api.put(
			this.url(`/update-consumer-roles/${id}`),
			data,
			"errors.update-user-roles-failed"
		);
	}

	users(): Observable<UserStatusResponse[]> {
		return this.api.get<UserStatusResponse[]>(this.url(`/users`), "errors.get-all-users-failed");
	}

	getConsumerRoles(): Observable<any> {
		return this.api.get(this.url(`/get-consumer-roles`), "errors.retrieve-consumer-roles-failed");
	}

	getActiveVendorOwners(): Observable<any[]> {
		return this.api.get(this.url(`/get-active-vendor-owners`), "errors.get-active-vendors-failed");
	}
}
